import { Card, Text } from "@mantine/core"
import type { ReactNode } from "react"

export function MetricCard({ label, value }: { label: string; value: ReactNode }) {
  return (
    <Card withBorder radius="sm" p="sm">
      <Text c="dimmed" size="xs">
        {label}
      </Text>
      <Text fw={700}>{value}</Text>
    </Card>
  )
}
